<template>
  <div class="aside__search aside__block">
    <form action="" class="catalog-search">
      <div class="heading-for-aside">Поиск по категории {{ group.name }}</div>
      <div class="catalog-search__body">
        <input v-model="search"
               type="search" id="cat-cons-form_name" class="catalog-search__input input-v2 input-v2_medium"
               placeholder="Я хочу найти...">
        <button class="catalog-search__button button-v2 button-v2_transparent-3 button-v2_small">
          <div class="button-v2__inner">
            <div class="button-v2__icon-box">
              <svg preserveAspectRatio="none" viewBox="0 0 24 24" fill="none" class="button-v2__icon"
                   xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M15.906 17.32a8 8 0 1 1 1.414-1.414l4.923 4.922-1.415 1.415-4.922-4.923zM17 11a6 6 0 1 1-12 0 6 6 0 0 1 12 0z"/>
              </svg>
            </div>
          </div>
        </button>
      </div>
      <a :href="'/search?search='+search" style="margin-top: 10px;"
         class="button-as-link button-as-link_solid filters__link">
        <div class="button-as-link__label">Поиск по всем категориям</div>
      </a>
    </form>


    <button @click="showFilters"
            class="button-v2 button-v2_colored-1 button-v2_small filter-control-button">
      <div class="button-v2__inner">
        <div class="button-v2__label">Фильтры</div>
      </div>
    </button>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "SearchInGroup",
  data() {
    return {
      search: ""
    }
  },
  computed: {
    ...mapGetters({
      group: 'group_info/GET_GROUP_INFO',
    }),
  },

  methods: {
    showFilters() {
      this.$store.commit('group_info/CHANGE_SHOW_FILTERS')
    },
  },
  beforeMount() {
    let search = window.url_helpers.get_search()
    if (search != null && search.length > 2) {
      this.search = search
    }
  },
  watch: {
    search() {
      if (this.search.length > 2) {
        this.$store.dispatch('group_info/SET_SEARCH', this.search)
      } else if (this.search.length == 0) {
        this.$store.dispatch('group_info/SET_SEARCH', "")
      }
      window.url_helpers.set_search(this.search)
    },
  },
}
</script>

<style scoped>

</style>